export class Cookie {

    public static get pagename() : string { return Cookie.get('pagename'); }
    public static get username() : string { return Cookie.get('username'); }
    public static get theme() : string { return Cookie.get('theme'); }

    public static set pagename(v:string) { Cookie.set('pagename',v); }
    public static set username(v:string) { Cookie.set('username',v); }
    public static set theme(v:string) { Cookie.set('theme',v); }

    public static clearPagename() : void { Cookie.delete('pagename'); }
    public static clearUsername() : void { Cookie.delete('username'); }
    public static clearTheme() : void { Cookie.delete('theme'); }

    private static set(name: string, value: string, days: number | false = false): void {

        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + ((days as number) * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    private static get(name: string): string {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) == 0) {
                const ret =c.substring(nameEQ.length, c.length);
                return  ret;
            }
        }
        return '';
    }

    private static delete(name: string): void {
        document.cookie = name + '=; Max-Age=-99999999;';
    }

}
